exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drawings__list[data-v-3b4f43ca]{margin-top:40px;padding:0;list-style:none}.drawings__item[data-v-3b4f43ca]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;justify-content:space-between;align-items:flex-start;padding:20px;box-shadow:0 2px 5px 0 #666;border-radius:8px;margin-bottom:20px}.drawings__item img[data-v-3b4f43ca]{width:100px;margin-left:20px}", ""]);

// exports
